if (!customElements.get("product-variant-selects-upsell")) {

class ProductVariantSelectsUpsell extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {debugger;
      console.log("No current variant found:", this.currentVariant);
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
       console.log("Variant changes 1");
    });
   
  }

//  updateMasterId() {
//     const variantData = this.getVariantData();
//     console.log(variantData); // Inspect this value
//     if (Array.isArray(variantData)) {
//         this.currentVariant = variantData.find((variant) => {
//             return !variant.options
//                 .map((option, index) => {
//                     return this.options[index] === option;
//                 })
//                 .includes(false);
//         });
//         console.log("Variant changes 2");
//     } else {
//         console.error('getVariantData() did not return an array');
//     }
// }


  // new function start 
updateMasterId() {
    try {
        const variantData = this.getVariantData();
        console.log(variantData); // Inspect this value

        if (Array.isArray(variantData)) {
            // Handle the case where variantData is an array
            this.currentVariant = variantData.find((variant) => {
                if (!variant.options) {
                    console.warn('Variant does not have options:', variant);
                    return false;
                }
              if(this.options[0] == variant.id){
                return variant;
              }
            });

            if (this.currentVariant) {
                console.log('Found variant:', this.currentVariant);
            } else {
                console.log('No matching variant found.');
                // Optionally set a default value or perform additional actions here
                // this.currentVariant = this.getDefaultVariant();
            }
        } else {
            // Handle the case where variantData is not an array
            console.log('VariantData is not an array, attempting to match single value:', variantData);

            // Example: Assuming variantData is a single variant object or value
            const singleValueMatch = this.options.includes(variantData);
            
            if (singleValueMatch) {
                console.log('Single value matches one of the options.');
                // Optionally set this as the currentVariant if it makes sense in your context
                // this.currentVariant = { options: [variantData] };
            } else {
                console.log('Single value does not match any options.');
                // Optionally set a default value or perform additional actions here
                // this.currentVariant = this.getDefaultVariant();
            }
        }
    } catch (error) {
        console.error('Error in updateMasterId:', error);
        // Optionally, handle or recover from the error
        // this.currentVariant = this.getDefaultVariant();
    }
}


// new function end 



   updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      // var className = productForm.querySelector('.product-widget-item-image img');
      var imageId = this.id;
      imageId = "product-widget-item-image-" + imageId;
      var imageUrl = this.currentVariant.featured_image.src;
      $("."+imageId).attr('src', imageUrl);
      
      input.value = this.currentVariant.id;
       console.log("Variant changes 3");
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if(this.currentVariant.available){
        this.toggleAddButton(false, '', false);
      }
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }



  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
 
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      // if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      // addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('product-variant-selects-upsell', ProductVariantSelectsUpsell);
}